var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],ref:"span",class:{'got-a-notice': _vm.notice!=''},attrs:{"title":_vm.notice}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }